<rav-mobile-actions
  *ngIf="config.actions && mobileTable.isSelectingItems"
  data-cy="mobile-actions"
  [totalItems]="totalItems"
  [actions]="config.actions"
  [selectedItems]="selection.selected"
  (actionTriggered)="onActionTriggered($event)"
  (cancelClick)="onMobileActionsCancelClick()"
  class="hide-for-medium"
></rav-mobile-actions>

<h1 *ngIf="config.isSearchable && (mobile.isMobileDisplay() ? !mobileTable.isSelectingItems : true)">
  <rav-editor [isLink]="false" [currentText]="headerText"></rav-editor>
</h1>

<rav-version #version> </rav-version>

<div class="grid-x align-justify align-top">
  <div class="cell small-12 large-auto">
    <h1 *ngIf="!config.isSearchable && (mobile.isMobileDisplay() ? !mobileTable.isSelectingItems : true)">
      <rav-editor #editor [isLink]="false" [currentText]="headerText"></rav-editor>
    </h1>
    <rav-table-search
      *ngIf="config.isSearchable"
      [dataType]="config.dataType"
      [searchLabel]="config.searchLabel"
      (newSearch)="onNewSearch($event)"
    ></rav-table-search>
  </div>
  <div class="cell small-12 large-shrink show-for-medium">
    <rav-actions
      *ngIf="config.actions"
      [isTable]="true"
      [totalItems]="totalItems"
      [actions]="config.actions"
      [selectedItems]="selection.selected"
      (actionTriggered)="onActionTriggered($event)"
    ></rav-actions>
  </div>
</div>

<rav-query-param-message></rav-query-param-message>

<mat-progress-bar *ngIf="dataSource.isLoading$ | async" mode="indeterminate"></mat-progress-bar>

<div
  class="table-container show-for-medium"
  [hidden]="!(paginatorLength$ | async) && !(dataSource.isLoading$ | async)"
  [class.cursor__move]="dragDrop.isDragging && dragDrop.target && dragDrop.target.region === DragDropRegion.TableRow"
>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    multiTemplateDataRows
    mat-elevation-z8
    cdkDropList
    cdkDropListSortingDisabled
    (mouseleave)="dragDrop.target = undefined"
    [class.table--nonselectable]="!columnsToDisplay.includes('select')"
  >
    <ng-container matColumnDef="select" sticky>
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          #selectAll
          color="primary"
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && areAllRowsSelected()"
          [indeterminate]="selection.hasValue() && !areAllRowsSelected()"
        ></mat-checkbox>
      </mat-header-cell>

      <mat-cell *matCellDef="let row; let i = dataIndex">
        <mat-checkbox
          data-cy="table-row-checkbox"
          *ngIf="!processingDictionary[row.id]"
          [id]="'checkbox' + row.id"
          color="primary"
          (mousedown)="onRowSelected($event, i)"
          (click)="(false)"
          [checked]="selection.isSelected(row)"
        ></mat-checkbox>
        <rav-loader *ngIf="processingDictionary[row.id]" type="icon"> </rav-loader>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="mobileAction" stickyEnd data-cy="table-mobile-action">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>

      <mat-cell *matCellDef="let row; let i = dataIndex">
        <button
          class="small clear button margin-0"
          (click)="openActionsMenu($event, row)"
          [disabled]="processingDictionary[row.id]"
        >
          <rav-icon [name]="RavIconCircledOutlined.More" class="page__icon--large"> </rav-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container *ngFor="let column of config.columns" [matColumnDef]="column.key">
      <mat-header-cell *matHeaderCellDef [ngClass]="getCellClass(column.key, '', true)">
        <a *ngIf="column.key === 'role'" class="table__info" [matMenuTriggerFor]="helpRolesMenu" data-cy="role-help">
          <i class="fa fa-question-circle"></i>
        </a>

        <mat-menu #helpRolesMenu="matMenu" class="mat-menu--with-content">
          <rav-help-roles></rav-help-roles>
        </mat-menu>

        <span mat-sort-header>
          {{ column.header ? (column.header | titlecase) : (column.key | snakeCaseToHuman | titlecase) }}
        </span>
      </mat-header-cell>

      <mat-cell
        *matCellDef="let row; let i = dataIndex"
        data-cy="table-cell"
        [ngClass]="getCellClass(column.key, row[column.key])"
      >
        <!-- If the columnxRow has an icon, it is shown here -->
        <rav-icon
          *ngIf="column.icon"
          [name]="typeOf(column.icon) === 'string' ? column.icon : column.icon(row)"
          class="cell sidebar__icon dark-color table-icon"
          [title]="column.tooltip ? (typeOf(column.tooltip) === 'string' ? column.tooltip : column.tooltip(row)) : ''"
        ></rav-icon>

        <!-- 'title' columnxRow value options  -->
        <rav-editor
          *ngIf="column.link && !rowHasError(row)"
          [disabled]="processingDictionary[row.id] || (dragDrop.isDragging && selection.selected.includes(row))"
          [currentText]="row[column.key] | tableCell: column.key"
          [isLink]="row.internal_link !== null"
          [editType]="row['type']"
          [id]="row['id']"
          [link]="typeOf(column.link) === 'string' ? uriWithId(column.link, row) : uriWithId(column.link(row), row)"
          (editionEvent)="updateLocalAttributes($event, row)"
        ></rav-editor>
        <p class="title-error" *ngIf="column.key === 'title' && rowHasError(row)">
          {{ row[column.key] | tableCell: column.key }}
          <rav-icon
            [name]="'alert'"
            class="table-row-error__icon"
            matTooltip="The document encountered an error and is unavailable"
            matTooltipClass="table-row-error__tooltip"
          ></rav-icon>
        </p>

        <!-- 'action' columnxRow value link -->
        <a
          *ngIf="column.action && scope.hasAccess(column.action.scope)"
          (click)="onRowActionTriggered(column.action.name, row)"
        >
          {{ column.action.cellValueOverride || (row[column.key] | tableCell: column.key) }}
        </a>

        <!-- 'version' columnxRow value options -->
        <div *ngIf="column.key === 'version'">
          <div *ngIf="row[column.key]; else elseBlock1">
            <a
              *ngIf="!rowHasError(row); else elseBlock2"
              (click)="!processingDictionary[row.id] && version.open(row)"
              [class.table__row-disabled]="processingDictionary[row.id]"
              >{{ row[column.key] | tableCell: column.key }}</a
            >
            <ng-template #elseBlock2>
              -
            </ng-template>
          </div>
          <ng-template #elseBlock1>
            {{ row[column.key] | tableCell: column.key }}
          </ng-template>
        </div>

        <!-- 'size' columnxRow value options -->
        <div *ngIf="column.key && column.key === 'size_in_mb'">
          <div *ngIf="!rowHasError(row); else elseBlock">
            {{ row[column.key] | tableCell: column.key }}
          </div>
          <ng-template #elseBlock>
            -
          </ng-template>
        </div>

        <ng-container *ngIf="column.additionalInfo">
          <img
            class="cell sidebar__icon dark-color table-icon"
            src="assets/icons/{{ row[column.key] }}-outbox.svg"
            alt="{{ row[column.key] }} icon"
          />
          {{ format.formatDestinationRecipient(row[column.key], row[column.additionalInfo]) }}
        </ng-container>
        <ng-container
          *ngIf="
            !column.link &&
            !column.icon &&
            !column.action &&
            !column.additionalInfo &&
            column.key !== 'version' &&
            column.key !== 'size_in_mb' &&
            !(column.key === 'title' && rowHasError(row))
          "
          >{{ row[column.key] | tableCell: column.key }}</ng-container
        >
      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="columnsToDisplay"
      (mouseenter)="dragDrop.target = undefined"
      (drop)="dropHandler($event)"
      (dragover)="dragOverHandler($event)"
      (dragleave)="dragLeaveHandler($event)"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: columnsToDisplay; let i = dataIndex"
      [id]="'row' + row.id"
      (contextmenu)="!processingDictionary[row.id] && openActionsMenu($event, row)"
      (mousedown)="!processingDictionary[row.id] && onRowSelected($event, i)"
      (dblclick)="!processingDictionary[row.id] && viewRow(row)"
      [class.table__row-disabled]="
        processingDictionary[row.id] || (dragDrop.isDragging && selection.selected.includes(row))
      "
      [class.table__row-selected]="!processingDictionary[row.id] && selection.isSelected(row)"
      [class.table__row-error]="rowHasError(row)"
      cdkDrag
      [cdkDragDisabled]="
        mobile.isMobileDisplay() ||
        !config.canDragRows ||
        isRowEditorOpen ||
        processingDictionary[row.id] ||
        rowHasError(row)
      "
      (cdkDragStarted)="onDrag(row)"
      (cdkDragEnded)="onDrop()"
      (mouseenter)="dragDrop.target = { region: DragDropRegion.TableRow, value: row }"
      (mouseleave)="dragDrop.target = undefined"
      (drop)="dropHandler($event, row)"
      (dragover)="dragOverHandler($event, row)"
      (dragleave)="dragLeaveHandler($event)"
    >
      <div *cdkDragPreview class="drag-drop__preview primary-bg light-color">
        <rav-icon [name]="RavIconOutlined.Move" class="drag-drop__preview-icon"></rav-icon>
        MOVE
        <div class="drag-drop__preview__badge secondary-bg primary-color">{{ selection.selected.length }}</div>
      </div>
    </mat-row>
  </table>
</div>

<rav-mobile-table
  #mobileTable
  [actions]="config.actions"
  [columnsToDisplay]="columnsToDisplay"
  [config]="config"
  [dataRows]="dataRows"
  [masterToggleStatus]="getMasterToggleStatus()"
  [processingDictionary]="processingDictionary"
  [selectionChanges]="selectionChangesSubject.asObservable()"
  [sortChanges]="sortChangesSubject.asObservable()"
  (addClick)="onActionTriggered($event)"
  (rowClick)="viewRow($event)"
  (sortUpdate)="updateSort($event)"
  (toggleClick)="masterToggle($event)"
  (rowOptionsButtonClick)="openMobileActionsMenu($event)"
  (selectionMade)="onMobileRowSelected($event)"
  class="hide-for-medium"
></rav-mobile-table>

<div
  #rightClickMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="rightClickMenu"
  style="position: fixed"
  [style.left]="rightClickMenuPosition.x"
  [style.top]="rightClickMenuPosition.y"
>
  <mat-menu #rightClickMenu="matMenu" class="right-click-menu">
    <div class="grid-y">
      <div *ngFor="let action of contextMenuConfig.actions; let i = index" class="cell shrink">
        <div
          *ngIf="
            scope.hasAccesses(action.scope) &&
            TableActions.isEnabled(action, selection.selected) &&
            TableActions.shouldShow(action, selection.selected) &&
            !action.enabledRules.includes(ActionEnabledRule.Always)
          "
        >
          <button
            (click)="onRightClickMenuAction(action.name)"
            class="dropdown__button flex-container align-middle padding-horizontal-1"
          >
            <span class="dropdown__icon padding-right-1" [class.table__mobile-dropdown-icon]="mobile.isMobileDisplay()"
              ><rav-icon [name]="!mobile.isMobileDisplay() ? action.iconEnabled : action.mobileIcon"></rav-icon>
            </span>
            {{ action.name }}
          </button>
        </div>
      </div>
    </div>
  </mat-menu>
</div>

<h5 *ngIf="!(paginatorLength$ | async) && (dataSource.isLoading$ | async)">Loading...</h5>

<div [hidden]="!(paginatorLength$ | async) && !(dataSource.isLoading$ | async)">
  <mat-paginator
    id="table-paginator"
    class="background"
    [class.table__mobile-paginator]="mobile.isMobileDisplay() && !config.mobileSettings.preventFixedPaginator"
    [length]="paginatorLength$ | async"
    [pageSize]="config.fixedPageSize || localStorage.tablePerPage"
    [pageSizeOptions]="[10, 25, 50, 100]"
    [hidePageSize]="config.fixedPageSize"
    showFirstLastButtons
  ></mat-paginator>
</div>

<rav-no-content
  (mouseenter)="dragDrop.target = undefined"
  (drop)="dropHandler($event)"
  (dragover)="dragOverHandler($event)"
  (dragleave)="dragLeaveHandler($event)"
  *ngIf="!(paginatorLength$ | async) && !(dataSource.isLoading$ | async)"
></rav-no-content>
<rav-share-document [selectedDocuments]="selection.selected"></rav-share-document>

<div *ngIf="isDraggingOver && dragZoneRowTitle" class="grid-x drag-drop__banner" data-cy="drag-drop__banner">
  <div class="cell small-12 grid-y">
    <div class="cell">
      <rav-icon [name]="RavIcon.Upload" class="upload-icon"></rav-icon>
    </div>
    <div class="cell text-center grid-y drag-drop__banner__text">
      <div class="cell">Drop files to upload them to</div>
      <div class="cell">
        <div>{{ dragZoneRowTitle }}</div>
      </div>
    </div>
  </div>
</div>
